import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { AuthProvider } from '@/auth/AuthContext'
import { AppShell } from '@/components/layout/AppShell'
import { AdminAdminsPage } from '@/pages/AdminAdminsPage'
import { AdminApplicationDetailPage } from '@/pages/AdminApplicationDetailPage'
import { AdminApplicationsPage } from '@/pages/AdminApplicationsPage'
import { AdminEventsPage } from '@/pages/AdminEventsPage'
import { AdminVendorsPage } from '@/pages/AdminVendorsPage'
import { ApplicationFormPage } from '@/pages/ApplicationFormPage'
import { CalendarPage } from '@/pages/CalendarPage'
import { LoginPage } from '@/pages/LoginPage'
import { ProfilePage } from '@/pages/ProfilePage'
import { ResetPasswordPage } from '@/pages/ResetPasswordPage'
import { SignupPage } from '@/pages/SignupPage'
import { VendorApplicationEditPage } from '@/pages/VendorApplicationEditPage'
import { VendorDashboardPage } from '@/pages/VendorDashboardPage'
import { WelcomePage } from '@/pages/WelcomePage'

/** Application route table with vendor and admin areas. */
export function AppRouter() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<WelcomePage />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="reset-password" element={<ResetPasswordPage />} />
            <Route path="signup" element={<SignupPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="vendor" element={<VendorDashboardPage />} />
            <Route path="vendor/apply" element={<ApplicationFormPage />} />
            <Route path="vendor/applications/:id" element={<VendorApplicationEditPage />} />
            <Route path="admin" element={<AdminApplicationsPage />} />
            <Route path="admin/applications/:id" element={<AdminApplicationDetailPage />} />
            <Route path="admin/events" element={<AdminEventsPage />} />
            <Route path="admin/vendors" element={<AdminVendorsPage />} />
            <Route path="admin/admins" element={<AdminAdminsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
